import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";
import { legalServiceSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/aree/diritto-civile")({
  head: () => seoMeta({
    title: "AI per il diritto civile",
    description: "LexAIPro per avvocati civilisti: ricerca giurisprudenziale, analisi contratti e redazione di atti civili con AI specializzata.",
    path: "/aree/diritto-civile",
  }),
  component: () => (
    <ContentPage
      extraSchemas={[legalServiceSchema({ name: "LexAIPro - AI per il diritto civile", description: "Ricerca, analisi contratti e redazione atti per la pratica civilistica italiana.", path: "/aree/diritto-civile" })]}
      eyebrow="Aree di pratica"
      title="LexAIPro per il diritto civile"
      lead="Ricerca su codice civile e giurisprudenza di Cassazione, analisi contratti, redazione di atti e memorie. Pensato per la pratica civilistica italiana."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Aree",path:"/aree/diritto-civile"},{name:"Diritto civile",path:"/aree/diritto-civile"}]}
      sections={[
        { heading: "Casi d'uso tipici", bullets: ["Responsabilità civile e risarcimento danni","Obbligazioni e contratti","Diritti reali e condominio","Successioni e donazioni","Contenzioso ordinario"] },
        { heading: "Cosa ti dà LexAIPro", bullets: ["Ricerca su Cassazione civile e merito","Bozze di citazioni, comparse, memorie 183","Analisi clausole contrattuali","Estrazione automatica scadenze processuali"] },
      ]}
      faq={[
        { q: "Copre la giurisprudenza di merito?", a: "Sì, con priorità a Cassazione e Corti d'Appello." },
      ]}
      cta={{ label: "Prova gratis", to: "/signup" }}
      heroImage={pickContent(3)}
      updated="2026"
    />
  ),
});
